'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.omitby');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isFalsy = function isFalsy(x) {
  return !x;
};
var clean = function clean(object) {
  return (0, _lodash2.default)(object, isFalsy);
};

var hasLegacyLocations = function hasLegacyLocations(_ref) {
  var nation = _ref.nation;
  var state = _ref.state;
  var location = _ref.location;
  var area = _ref.area;
  var areaid = _ref.areaid;

  return typeof nation !== 'undefined' || typeof state !== 'undefined' || typeof location !== 'undefined' || typeof area !== 'undefined' || typeof areaid !== 'undefined';
};

var defaultWhereValue = function defaultWhereValue(locale) {
  return locale.toUpperCase() === 'NZ' ? 'All New Zealand' : 'All Australia';
};

exports.default = function (_ref2) {
  var locale = _ref2.locale;
  var searchQuery = _ref2.searchQuery;

  var defaultParams = {
    where: !hasLegacyLocations(searchQuery) ? defaultWhereValue(locale) : '',
    page: '1'
  };

  var expandedQuery = _extends({}, defaultParams, searchQuery);

  var advertiserid = expandedQuery.advertiserid;
  var advertisergroup = expandedQuery.advertisergroup;
  var companyid = expandedQuery.companyid;

  var standardParams = _objectWithoutProperties(expandedQuery, ['advertiserid', 'advertisergroup', 'companyid']);

  var mappedParams = {
    hirerid: advertiserid,
    hirergroup: advertisergroup,
    companyprofilestructureddataid: companyid
  };

  return clean(_extends({}, standardParams, mappedParams));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-search-query/build/convertToApiQuery.js
 ** module id = 562
 ** module chunks = 0
 **/